"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.INITIAL_SEARCH_QUERY = exports.ImageLibraryContext = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _imageLibrary = _interopRequireDefault(require("./image-library"));

var _recoil = require("recoil");

var _config = require("./config");

var _authUploadHelper = _interopRequireDefault(require("./helpers/auth-upload-helper"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ImageLibraryContext = _react["default"].createContext();
/**
 * @class ImageLibraryContainer
 * @extends {React.Component}
 * @param preSearchQuery not visible in the search bar, will be used for first render grid images
 */


exports.ImageLibraryContext = ImageLibraryContext;
var INITIAL_SEARCH_QUERY = 'random';
exports.INITIAL_SEARCH_QUERY = INITIAL_SEARCH_QUERY;

var convertProductToTokenurl = function convertProductToTokenurl(product) {
  if (_config.supportedProducts.includes(product)) {
    return (0, _config.tokenUrls)(product);
  }

  return (0, _config.tokenUrls)();
};

var imagePickerInitialState = {
  setReturnValue: null,
  onDelete: null,
  setBase64ReturnValue: null,
  visible: false,
  mobileDrawerOpen: false,
  scrollPosition: 0,
  type: 'images',
  siteId: null,
  useBase64Return: false,
  useDetailsScreen: true,
  dimensions: [],
  uploadOnly: false,
  tokenUrl: null,
  logoTabByDefault: false
};

var ImageLibraryContainer = function ImageLibraryContainer(_ref) {
  var _ref$preSearchQuery = _ref.preSearchQuery,
      preSearchQuery = _ref$preSearchQuery === void 0 ? '' : _ref$preSearchQuery,
      children = _ref.children;

  var _React$useState = _react["default"].useState({
    imagePicker: imagePickerInitialState,
    portalZIndex: 1500
  }),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      state = _React$useState2[0],
      setState = _React$useState2[1];

  var imagePicker = state.imagePicker; // if closing, reset the scrollposition on the main window

  _react["default"].useEffect(function () {
    if (!state.imagePicker.visible) {
      setTimeout(function () {
        window.scrollTo({
          top: state.imagePicker.scrollPosition
        });
      }, 1);
    }
  }, [state.imagePicker.visible]); // check if all our tags contain a key and a value


  var checkValidTags = function checkValidTags(tags) {
    return tags.filter(function (tag) {
      return tag.key && tag.key.length > 0 && tag.value && tag.value.toString().length > 0;
    }).length === tags.length;
  };

  var tagsToParams = function tagsToParams(tags) {
    if (Array.isArray(tags) && tags.length > 0) {
      return tags.reduce(function (initial, next) {
        return _objectSpread(_objectSpread({}, initial), {}, {
          tag: "".concat(next.key, "-").concat(next.value)
        });
      }, {});
    }

    return {};
  };

  var openImagePicker = function openImagePicker(properties) {
    if ('setReturnValue' in properties && typeof properties.setReturnValue === 'function') {
      var setReturnValue = properties.setReturnValue,
          onDelete = properties.onDelete,
          visible = properties.visible,
          mobileDrawerOpen = properties.mobileDrawerOpen,
          type = properties.type,
          product = properties.product,
          token = properties.token,
          useBearerAuth = properties.useBearerAuth,
          productJwtUrl = properties.productJwtUrl,
          logoMakerIntegrationUrl = properties.logoMakerIntegrationUrl,
          rest = (0, _objectWithoutProperties2["default"])(properties, ["setReturnValue", "onDelete", "visible", "mobileDrawerOpen", "type", "product", "token", "useBearerAuth", "productJwtUrl", "logoMakerIntegrationUrl"]);
      var checkType = !type ? 'images' : type;

      if (['videos', 'images'].indexOf(checkType) > -1) {
        var imagePickerProps = _objectSpread(_objectSpread(_objectSpread({}, imagePicker), rest), {}, {
          visible: true,
          scrollPosition: window.scrollY,
          type: checkType,
          logoMakerIntegrationUrl: logoMakerIntegrationUrl
        }); // we need to supply a tokenUrl to upload images.


        if (!product && !_config.supportedProducts.includes(product) && !productJwtUrl && !token) {
          throw new Error('Please supply a product through the "product" parameter. The options here are: "expresseditor, "appmarket", "controlpanel", "store". Also we need a auth token from the token/me call.');
        } else {
          if (useBearerAuth) {
            _authUploadHelper["default"].useBearerAuth = useBearerAuth;
          }

          _authUploadHelper["default"].authToken = token;
          _authUploadHelper["default"].tokenUrl = productJwtUrl || convertProductToTokenurl(product);
        } // Data properties


        if ('data' in properties) {
          // tags (for uploading images.)
          if ('tags' in properties.data) {
            if (!Array.isArray(properties.data.tags)) {
              throw new Error('Tags is not an array');
            }

            if (checkValidTags(properties.data.tags)) {
              imagePickerProps.tags = tagsToParams(properties.data.tags);
            } else {
              throw new Error('Tags are not in the correct format, they should contain "key" and "value"');
            }
          }
        }

        if ('extDisallowed' in properties) {
          imagePickerProps.extDisallowed = properties.extDisallowed;
        }

        if ('detailsScreen' in properties && properties.detailsScreen.show) {
          imagePickerProps.useDetailsScreen = true;

          if ('dimensions' in properties.detailsScreen && properties.detailsScreen.dimensions.length) {
            imagePickerProps.dimensions = properties.detailsScreen.dimensions;
          }
        }

        if ('setBase64ReturnValue' in properties) {
          console.warn('"setBase64ReturnValue" is not being used anymore. Nothing should change for you, all the values come through "setReturnValue" per default, which will yield an url and the values you would normally expect.');
        }

        if ('onDelete' in properties && typeof properties.onDelete === 'function') {
          imagePickerProps.onDelete = function (value) {
            return properties.onDelete(value);
          };
        }

        imagePickerProps.returnValue = function (value) {
          properties.setReturnValue(value);
        };

        setState({
          imagePicker: imagePickerProps
        });
      } else {
        console.warn('Incorrect type, has to be one of "videos" or "images"');
      }
    }
  };

  var setImageLibraryVisibility = function setImageLibraryVisibility(visibleState) {
    var setReturnValue = imagePickerInitialState.setReturnValue,
        onDelete = imagePickerInitialState.onDelete,
        rest = (0, _objectWithoutProperties2["default"])(imagePickerInitialState, ["setReturnValue", "onDelete"]);
    var lastScrollPosition = state.imagePicker.scrollPosition;
    setState(_objectSpread(_objectSpread({}, state), {}, {
      imagePicker: _objectSpread(_objectSpread({}, rest), {}, {
        setReturnValue: setReturnValue,
        onDelete: onDelete,
        visible: visibleState
      })
    })); // TODO needs a refactor

    setTimeout(function () {
      window.scrollTo({
        top: lastScrollPosition
      });
    }, 1);
  }; // TODO the idea here is to convert the return values to the
  // same object


  var returnValueWrapper = function returnValueWrapper(value) {
    return state.imagePicker.returnValue(value);
  };

  var deleteValueWrapper = function deleteValueWrapper(value) {
    return state.imagePicker.onDelete(value);
  };

  return /*#__PURE__*/_react["default"].createElement(ImageLibraryContext.Provider, {
    value: {
      openImagePicker: openImagePicker
    }
  }, children, /*#__PURE__*/_react["default"].createElement(_recoil.RecoilRoot, null, /*#__PURE__*/_react["default"].createElement(_imageLibrary["default"], (0, _extends2["default"])({
    setVisibility: function setVisibility() {
      return setImageLibraryVisibility(false);
    },
    returnValue: returnValueWrapper,
    onDelete: deleteValueWrapper,
    preSearchQuery: preSearchQuery || INITIAL_SEARCH_QUERY
  }, imagePicker))));
};

ImageLibraryContainer.propTypes = {
  preSearchQuery: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node])
};
var _default = ImageLibraryContainer;
exports["default"] = _default;